import { Invoice } from '../models/Invoices';

/** Factura pendiente de registrar en Contalink (sin erp_id ni erp_number). */
export function isPendingContalinkInvoice(invoice: Invoice): boolean {
  return !invoice.erp_id && !invoice.erp_number;
}
